import { searchMatters } from "@/shared/utils/matterSearch";
import { getValueLabel, type OptionItem } from "./fields";
import type { EnumFilterField } from "./types";

export function searchFilterOptions(
	field: EnumFilterField,
	options: ReadonlyArray<OptionItem>,
	query: string,
	caseListIds?: Set<string>,
): ReadonlyArray<OptionItem> {
	const q = query.trim().toLowerCase();
	if (!q) return options;
	if (field === "matter") {
		return searchMatters(
			options.map((option) => ({
				matter_id: option.value,
				matter: option.label,
				description: option.description || option.sublabel || "",
				client: option.client || "",
				option,
			})),
			q,
			caseListIds,
		).map((result) => result.option);
	}
	const tokens = field === "client" ? q.split(/\s+/) : [q];
	return options.filter((option) => {
		const label = getValueLabel(field, option.label).toLowerCase();
		const sublabel = option.sublabel?.toLowerCase() ?? "";
		const keywords =
			option.keywords?.map((keyword) => keyword.toLowerCase()) ?? [];
		return tokens.every(
			(token) =>
				label.includes(token) ||
				sublabel.includes(token) ||
				keywords.some((keyword) => keyword.includes(token)),
		);
	});
}
